/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from 'react';
import { connect } from 'react-redux';
import { Modal } from '@instructure/ui-modal';
import { Heading } from '@instructure/ui-heading';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { videoDeviceChanged } from '../../../actions';
import { HIDE_PIP_MODAL } from '../../../constants/ActionTypes';
import { translate } from '../../../constants/translated/translations';
function PipModal({
  showPipModal,
  enable,
  hideModal
}) {
  return /*#__PURE__*/React.createElement(Modal, {
    open: showPipModal,
    label: translate('PICTURE_IN_PICTURE_MODAL_HEADING')
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(CloseButton, {
    placement: "end",
    offset: "medium",
    onClick: hideModal,
    screenReaderLabel: translate('PICTURE_IN_PICTURE_MODAL_CLOSE')
  }), /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, translate('PICTURE_IN_PICTURE_MODAL_HEADING'))), /*#__PURE__*/React.createElement(Modal.Body, null, translate('PICTURE_IN_PICTURE_MODAL_BODY')), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    onClick: hideModal,
    margin: "0 x-small 0 0"
  }, translate('PICTURE_IN_PICTURE_MODAL_CANCEL')), /*#__PURE__*/React.createElement(Button, {
    onClick: enable,
    color: "primary"
  }, translate('PICTURE_IN_PICTURE_MODAL_CONFIRM'))));
}
const mapStateToProps = state => ({
  showPipModal: state.showPipModal
});
const mapDispatchToProps = dispatch => ({
  enable: () => dispatch(videoDeviceChanged()),
  hideModal: () => dispatch({
    type: HIDE_PIP_MODAL
  })
});
export default connect(mapStateToProps, mapDispatchToProps)(PipModal);